// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/analytics";
var firebaseConfig = {
  projectId: "cerdos-trufas",
  appId: "1:1073921305272:web:7a4977c1bfe707b279624d",
  databaseURL: "https://cerdos-trufas.firebaseio.com",
  storageBucket: "cerdos-trufas.appspot.com",
  locationId: "us-east1",
  apiKey: "AIzaSyB2BBUWYqll-rBh8x7wv3GzDyYC0eO4JeA",
  authDomain: "cerdos-trufas.firebaseapp.com",
  messagingSenderId: "1073921305272",
  measurementId: "G-HP9EG0V75L"
};
firebase.initializeApp(firebaseConfig);
firebase.analytics();
export default firebase;
